import { RemoveNoTransactionsPages } from 'core/types/Settings';
import { JsonObject } from '../types';

export class PdfReportsSettings {
  public removeNoTransactionsPages: RemoveNoTransactionsPages;

  constructor(json: JsonObject) {
    this.removeNoTransactionsPages = json.emptyPages ? json.emptyPages : 'SETTINGS_DOWNLOAD_PDF_EMPTY_PAGES_OPTION_A';
  }
}
